<template>
  <div class="custom-form-title">
    <div class="header" :style="{'padding':padding}" v-if="title">
      <div class="clearfix" >
        <div style="display: flex;align-items: center;">
          <img style="width: 4px;height: 20px;" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAaCAYAAACU2C2oAAAABHNCSVQICAgIfAhkiAAAAB1JREFUKFNjdM058p8BC2AclUAPldEgwUgnVAwSAH+YP+ND6egcAAAAAElFTkSuQmCC" />
          <span style="margin-left: 10px;font-size: 18px;" :style="{'color':color}">
            {{title}}</span>
        </div>
      </div>
    </div>
    <div>
      <div :style="{'width':body}" class="body">
        <slot></slot>
      </div>
    </div>

  </div>
</template>

<script>
  export default {

    props: {
      bodyWidth: {
        type: String,
        default: '100%'
      },
      color: {
        type: String,
        default: '#456CC4'
      },
      title: {
        type: String,
        default: ''
      },
      padding: {
        type: String,
        default: '18px 0px 0 0px'
      },
      body: {
        type: String,
        default: '100%'
      }
    },
    computed: {},
    methods: {}
  }
</script>

<style lang="scss">
  .custom-form-title {
    color: #303133;
    -webkit-transition: .3s;
    transition: .3s;

    .header {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
    }

    .body {}

  }
</style>



// WEBPACK FOOTER //
// src/components/basic/FwFormCard.vue